import { cn } from '@sohanemon/utils';
import type { ComponentProps } from 'react';

export function Chip({ className, ...props }: ComponentProps<'div'>) {
	return (
		<div
			className={cn(
				'rounded-full bg-primary/20 px-3 py-0.5 font-mono text-2xs text-primary uppercase',
				className,
			)}
			{...props}
		/>
	);
}
